var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSutures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1839 3.81615C19.6575 3.2899 18.9576 3 18.2133 3C17.469 3 16.769 3.2899 16.2428 3.81629C15.3493 4.70976 3.61318 19.5153 3.11412 20.1451C2.94768 20.355 2.96512 20.6563 3.1545 20.8455C3.25681 20.948 3.3918 21 3.52749 21C3.64284 21 3.75847 20.9624 3.85488 20.886C4.48467 20.3868 19.2903 8.65086 20.1837 7.75725C20.7101 7.231 21 6.53117 21 5.7867C21 5.04237 20.7102 4.34254 20.1839 3.81615V3.81615ZM18.5862 6.15955L16.9885 7.75712C16.8856 7.86011 16.7506 7.91161 16.6156 7.91161C16.4806 7.91161 16.3458 7.86011 16.2428 7.75712C16.0369 7.55126 16.0369 7.21727 16.2428 7.01141L17.8405 5.41385C18.0463 5.20799 18.3803 5.20799 18.5862 5.41385C18.7922 5.61971 18.7922 5.9537 18.5862 6.15955Z",
    fill: "#4807EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSutures);
export default __webpack_public_path__ + "static/media/sutures.0ed445c567b58f0b1515f1cc01c76493.svg";
export { ForwardRef as ReactComponent };